<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Transações em Chargeback</h3>
        </div>
        <!-- Page Header - Filters -->
        <div class="col-6 d-flex">
          <div class="input-group d-flex justify-content-end my-auto">
            <button
              type="button"
              class="btn btn-primary btn-sm mt-3"
              @click="OpenModalFilter()"
            >
              <i class="fas fa-filter"></i>
              {{ countFilter > 0 ? "Filtros aplicados" : "" }}
              <span v-if="countFilter > 0" class="badge badge-light">{{
                countFilter
              }}</span>
            </button>
            <button
              v-if="countFilter > 0"
              type="button"
              class="input-group-text btn-sm ml-1 mt-3"
              v-b-tooltip.hover.bottom
              title="Limpar filtros"
              @click="ResetFilter()"
            >
              <i class="fas fa-eraser"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Default Light Table -->
      <div class="row">
        <div class="col">
          <div class="card card-small mb-4">
            <div class="card-header border-bottom">
              <div class="float-left">
                <h6 class="m-0">Transações</h6>
              </div>
              <div v-if="pagination.TotalItems > 0" class="float-right">
                <b-input-group class="d-flex justify-content-end my-auto ml-2">
                  <h6 v-if="pagination.TotalItems > 0" class="m-0">
                    {{ pagination.TotalItems | number }}
                    {{ pagination.TotalItems > 1 ? " itens" : "item" }}
                  </h6>
                  <div class="dropdown m-0" v-if="pagination.TotalItems > 1">
                    <button
                      class="btn btn-outline-secondary dropdown-toggle-ellipsis"
                      type="button"
                      v-b-tooltip.hover.right
                      title="Mais opções"
                      id="dropdownMenuButton"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <i class="fas fa-ellipsis-v"></i>
                    </button>
                    <div
                      class="dropdown-menu"
                      id="dropTableOptions"
                      aria-labelledby="dropdownMenuButton"
                    >
                      <a
                        class="dropdown-item"
                        href="#"
                        :class="loadingReport ? 'disabled' : ''"
                        v-on:click.stop="GetReport($event)"
                      >
                        <template v-if="loadingReport">
                          <loader
                            :small="true"
                            :isLoading="loadingReport"
                          ></loader>
                        </template>
                        <template v-else>
                          <i class="fas fa-check mr-2"></i>
                          Gerar relatório
                        </template>
                      </a>
                    </div>
                  </div>
                </b-input-group>
              </div>
            </div>
            <div class="card-body p-0 pb-3 text-center">
              <loader :is-loading="loadingList"></loader>
              <table class="table mb-0" v-if="!loadingList">
                <thead class="bg-s2p-gray-light">
                  <tr>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0 text-left">
                      {{ labelId }}
                    </th>
                    <th scope="col" class="border-0 text-left">
                      {{ labelIdTransactionStatus }}
                    </th>
                    <th scope="col" class="border-0 text-left">
                      {{ labelIdMerchant }}
                    </th>
                    <th scope="col" class="border-0">
                      {{ labelIdMerchantRoot }}
                    </th>
                    <th scope="col" class="border-0 text-left">
                      {{ labelName }}
                    </th>
                    <th scope="col" class="border-0 text-left">
                      {{ labelNameCustomer }}
                    </th>
                    <th scope="col" class="border-0">{{ labelAmount }}</th>
                    <th scope="col" class="border-0">{{ labelPaymentDate }}</th>
                    <th scope="col" class="border-0">
                      {{ labelMaskedCardNumber }}
                    </th>
                    <th scope="col" class="border-0">
                      {{ labelReasonMessage }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(transaction, index) in transactions" :key="index">
                    <td></td>
                    <td class="text-left">{{ transaction.Id }}</td>
                    <td class="text-left">
                      {{ transaction.TransactionStatus.Id }}
                    </td>
                    <td class="text-left">{{ transaction.Merchant.Id }}</td>
                    <td v-if="transaction.Merchant.IdMerchantRoot > 0">
                      {{ transaction.Merchant.IdMerchantRoot }}
                    </td>
                    <td v-if="transaction.Merchant.IdMerchantRoot == 0">
                      <i
                        :class="[
                          GetIdMerchantRootClass(
                            transaction.Merchant.IdMerchantRoot
                          ),
                        ]"
                      ></i>
                    </td>
                    <td class="text-left">{{ transaction.Merchant.Name }}</td>
                    <td class="text-left">{{ transaction.Customer.Name }}</td>
                    <td>{{ transaction.Amount | currency }}</td>
                    <td>{{ transaction.PaymentDate | date }}</td>
                    <td>
                      {{ transaction.PaymentObject.MaskedCardNumber || "-" }}
                    </td>
                    <td>
                      {{ transaction.PaymentObject.Chargeback.ReasonMessage }}
                    </td>
                  </tr>
                  <tr
                    v-if="
                      transactions == undefined ||
                      transactions == null ||
                      transactions.length == 0
                    "
                  >
                    <td colspan="5">Sem registros</td>
                  </tr>
                </tbody>
              </table>

              <div class="col-12 border-top">
                <div class="pagination-nav">
                  <b-pagination
                    class="float-right"
                    v-model="pagination.PageNumber"
                    :total-rows="pagination.TotalItems"
                    :per-page="pagination.RowsPerPage"
                    aria-controls="my-table"
                  ></b-pagination>
                  <div class="float-left">
                    <d-select size="sm" v-model="pagination.RowsPerPage">
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                      <option value="500">500</option>
                    </d-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      id="mFilter"
      title="Filtros"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <d-form-row>
        <d-col md="6" class="form-group">
          <input
            :placeholder="labelIdMerchant"
            type="text"
            class="form-control"
            v-model="filter.IdMerchant"
            v-on:keyup.enter="Filter()"
          />
        </d-col>
        <d-col md="6" class="form-group">
          <input
            :placeholder="labelName"
            type="text"
            class="form-control"
            v-model="filter.NameMerchant"
            v-on:keyup.enter="Filter()"
          />
        </d-col>
        <d-col md="6" class="form-group">
          <input
            :placeholder="labelIdMerchantRoot"
            type="text"
            class="form-control"
            v-model="filter.IdMerchantRoot"
            v-on:keyup.enter="Filter()"
          />
        </d-col>
        <d-col md="6" class="form-group">
          <input
            :placeholder="labelNameCustomer"
            type="text"
            class="form-control"
            v-model="filter.NameCustomer"
            v-on:keyup.enter="Filter()"
          />
        </d-col>
      </d-form-row>

      <template slot="modal-footer">
        <b-button
          variant="primary"
          class="btn btn-primary"
          v-b-tooltip.hover.bottom
          title="Pesquisar"
          @click="Filter()"
        >
          <i class="fas fa-search"></i>
        </b-button>
        <b-button
          variant="primary"
          class="input-group-text"
          v-b-tooltip.hover.bottom
          title="Limpar filtros"
          @click="ResetFilter()"
        >
          <i class="fas fa-eraser"></i>
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { hasValue } from "../../utils/functions.js";
import dateField from "../common/date-field";
export default {
  name: "chargeback-dashboard-brand",
  components: {
    dateField,
  },
  data: function () {
    return {
      countFilter: 0,
      filter: {
        IdMerchant: null,
        IdMerchantRoot: null,
        NameMerchant: null,
        NameCustomer: null,
      },
      labelId: "Id",
      labelIdMerchant: "Id Empresa",
      labelIdMerchantRoot: "Id Marketplace",
      labelName: "Empresa",
      labelNameCustomer: "Cliente",
      labelAmount: "Valor",
      labelIdTransactionStatus: "Id Transaction Status",
      labelPaymentDate: "Data do Pagamento",
      labelMaskedCardNumber: "Número do Cartão Mascarado",
      labelReasonMessage: "Motivo",
      loadingList: false,
      loadingReport: false,
      pagination: {
        PageNumber: 1,
        RowsPerPage: 10,
        TotalItems: 0,
      },
      transactions: [],
    };
  },
  computed: {},
  watch: {
    "pagination.PageNumber": function () {
      this.GetBrand(this.idBrand);
    },
    "pagination.RowsPerPage": function () {
      this.GetBrand(this.idBrand);
    },
  },
  mounted() {
    this.idBrand = this.$route.params.idBrand;
    this.referenceDate = this.$route.query.referenceDate;
    this.idMcc = this.$route.query.idMcc;
    this.GetBrand(this.idBrand);
  },
  methods: {
    OpenModalFilter: function () {
      this.$bvModal.show("mFilter");
    },
    GetIdMerchantRootClass: function (idMerchantRoot) {
      return idMerchantRoot == 0 ? "fas fa-minus" : "";
    },
    Filter: function () {
      this.$bvModal.hide("mFilter");
      this.GetBrand(this.idBrand);
    },
    GetBrand: function (id) {
      this.countFilter = 0;
      if (hasValue(this.filter.NameCustomer)) this.countFilter++;
      if (hasValue(this.filter.NameMerchant)) this.countFilter++;
      if (hasValue(this.filter.IdMerchant)) this.countFilter++;
      if (hasValue(this.filter.IdMerchantRoot)) this.countFilter++;
      this.loadingList = true;
      let data = {
        ...this.pagination,
        ...{
          "Object.PaymentObject.Brand.Id": id,
          "Object.PaymentDate": this.referenceDate,
          "Object.PaymentObject.IdMcc": this.idMcc,
          "Object.Merchant.Id": this.filter.IdMerchant,
          "Object.Merchant.Name": this.filter.NameMerchant,
          "Object.Merchant.IdMerchantRoot": this.filter.IdMerchantRoot,
          "Object.Customer.Name": this.filter.NameCustomer,
        },
      };
      delete data.TotalItems;
      this.$store
        .dispatch("GetBrand", { params: data })
        .then((response) => {
          this.transactions = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao listar as transações em chargeback",
            error
          );
        })
        .finally(() => (this.loadingList = false));
    },
    GetReport: function (ev) {
      ev.preventDefault();
      this.loadingReport = true;
      const params = {
        "Object.PaymentObject.Brand.Id": this.idBrand,
        "Object.PaymentDate": this.referenceDate,
        "Object.PaymentObject.IdMcc": this.idMcc,
        "Object.Merchant.Id": this.filter.IdMerchant,
        "Object.Merchant.IdMerchantRoot": this.filter.IdMerchantRoot,
        "Object.Merchant.Name": this.filter.NameMerchant,
        "Object.Customer.Name": this.filter.NameCustomer,
      };
      this.$store
        .dispatch("ReportBrand", { params: params })
        .then((response) => {
          if (
            response.UrlReport != null &&
            response.UrlReport != undefined &&
            response.UrlReport != ""
          ) {
            this.$makeToast(
              "Aguarde a conclusão do download",
              "info",
              "Relatório gerado com sucesso"
            );
            window.open(response.UrlReport, "_self");
          }
        })
        .catch((error) => {
          this.$makeToast(
            "Tente novamente mais tarde.",
            "danger",
            "Erro ao gerar o relatório",
            error
          );
        })
        .finally(() => {
          $("#dropTableOptions").dropdown("hide");
          setTimeout(() => {
            this.loadingReport = false;
          }, 1200);
        });
    },
    ResetFilter: function () {
      this.filter = {
        NameCustomer: null,
        NameMerchant: null,
        IdMerchant: null,
        IdMerchantRoot: null,
      };
      this.GetBrand(this.idBrand);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/chargebackBrand.vue